module.exports = __webpack_public_path__ + "static/img/happy4.d96c7c96.png";